    let startNum = 0;
let endNum = 300;
const duration =  1000; // 1000 milliseconds 

$w.onReady(function () {
	setInterval(()=> {
		countUp(); 	
	}, duration);
});

function countUp(){ 
 if (startNum <= endNum ){   
        $w('#text4').text =  startNum.toLocaleString().toString();
        startNum++;
    }
}